// src/components/MemoryUpload.jsx
import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import './MemoryUpload.css';

function MemoryUpload({ onUpload }) {
  const [uploading, setUploading] = useState(false);

  const handleUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploading(true);

    const fileExt = file.name.split('.').pop();
    const fileName = `${Date.now()}.${fileExt}`;

    // 1. Supabase Storage 업로드
    const { error: uploadError } = await supabase.storage
      .from('memories') // ✅ 버킷 이름
      .upload(fileName, file);

    if (uploadError) {
      alert('Upload failed.');
      setUploading(false);
      return;
    }

    // 2. Public URL 얻기
    const {
      data: { publicUrl },
    } = supabase.storage.from('memories').getPublicUrl(fileName);

    // 3. DB에 삽입
    const { error: insertError } = await supabase
      .from('memories') // ✅ 테이블 이름
      .insert([{ url: publicUrl, created_at: new Date().toISOString() }]);

    if (insertError) {
      alert('DB insert failed.');
    } else {
      onUpload(); // 목록 갱신
    }

    setUploading(false);
  };

  return (
    <div className="memory-upload-box">
      <input type="file" accept="image/*" onChange={handleUpload} />
      {uploading && <p>업로드 중...</p>}
    </div>
  );
}

export default MemoryUpload;
